// extracted by mini-css-extract-plugin
export var box = "_8v-1";
export var checked = "_8v-2";
export var descriptionSpacer = "_8v-9";
export var disabled = "_8v-3";
export var icon = "_8v-6";
export var input = "_8v-0";
export var labelSpacer = "_8v-8";
export var medium = "_8v-5";
export var small = "_8v-4";
export var text = "_8v-7";